module.exports = __webpack_public_path__ + "img/3point.bfd26f84.png";